<template>
<div class="o_page">
  <img src="../../images/coins_order_bg.jpg" class="banner_pic" />
  <form @submit.prevent="submitOrder">
    <div class="order_box">
      <input placeholder="粘贴宝贝订单号赚券币" class="order_text" v-model="order" /><input type="submit" class="order_btn" value="提交赚券币">
    </div>
  </form>
  <div class="course">
    <div class="course_title">订单号说明 </div>
    <div class="course_text">凡领取[搜券王]优惠券购买的宝贝订单号都可提交赚取</div>
    <img src="https://souquan.wang/api/images/orderidhelp.png" class="course_img" />
  </div>
</div>
</template>
<script type = "text/ecamscript-6">
import {
  MessageBox
} from 'mint-ui';
export default {
  name: "orderScore",
  data() {
    return {
      order: "",
      openID: JSON.parse(sessionStorage.userInfo).openId
    }
  },
  created() {

  },
  methods: {
    submitOrder() {
      if (this.order.match(/^\d{16,18}$/)) {
        this.$ajax.autoService.
        login("api/addOrderScore.php?orderid=" + this.order + "&openid=" + this.openID).then((res) => {
          if(res.data>0){
            MessageBox({
              title:'订单编号提交成功',
              message: '1、在您的订单确认收货前，券币会临时被冻结。2、只有通过搜券王下的单，才有券币奖励。3、如果您是刚下的订单，券币获取会有几秒的延迟，可通过下拉来刷新。4、如果您没查到券币，请确认订单号是否输入正确。',
              showConfirmButton:true,
              showCancelButton:true,
              confirmButtonText:"查看券币",
              cancelButtonText:"我知道了"
              }).then(action => {
              if(action=="confirm"){
                this.$router.push('coinsCenter')
              }
});
          }
          else{
            MessageBox({
              title:'提示',
              message: '已提交过',
            })
          }
        })
      } else {
        MessageBox({
          title: "提示",
          message: "订单编号格式不正确，请参考下面的帮助，在手机淘宝上，我的订单打开宝贝的订单详情，在详情的最下方，有订单编号，点右边的复制即可"
        })
      }
    }

  }
}
</script>
<style lang="stylus">
  .o_page
    width:100%
    height:100%
    position:fixed
    left:0px
    top:0px
    background:#fff
    .banner_pic
      width:100%
      height:269px
      display:block
    .order_box
      width:670px
      height:72px
      margin-top:25px
      display:flex
      font-size:0px
      margin:20px auto 0 auto
      .order_text
        flex 0 0  480px
        width:480px
        height:72px
        border-left:1px solid #fe833d
        /*px*/
        border-bottom:1px solid #fe833d
        /*px*/
        border-top:1px solid #fe833d
        /*px*/
        box-sizing:border-box
        font-size:28px
        color:#333
        background:#fff9f6
        border-radius:15px 0 0 15px
        text-indent:1em
        color:#333
        &::-webkit-input-placeholder
          color:#fb7736
          text-align:center
      .order_btn
        flex:1
        height:72px
        background:linear-gradient(to right,#ff6f25,#ff0026)
        border-radius:0 15px 15px 0
        border:0px solid #fff
        font-size:28px
        color:#fff
    .course
      padding:110px 40px
      box-sizing:border-box
      .course_title
        font-size:30px
        color:#666
      .course_text
        font-size:26px
        color:#999
        margin-top:5px
      .course_img
        width:100%
        margin-top:25px
  .mint-msgbox-title
    font-size:30px
  .mint-msgbox-message
    font-size:26px
    line-height:45px
  .mint-msgbox-btns
    height:70px
    line-height:70px
  .mint-msgbox-btn
    font-size:26px

</style>



// WEBPACK FOOTER //
// src/components/userCenter/orderScore.vue